import React from "react";
import { render } from "react-snapshot";
import { Provider } from "react-redux";
import { Router, Route, Redirect, Switch } from "react-router-dom";
import Auth from "./components/auth/auth";
import Login from "./components/Login/Login";
import Callback from "./components/callback/callback";
import Header from "./components/Header/Header";
import history from "./history";

// import ReactGA from 'react-ga';

import RootContainer from "./containers/RootContainer/RootContainer";

import configureStore from "./store/configureStore";

import "./index.css";

const store = configureStore();

const auth = new Auth();
const handleAuthentication = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication();
  }
};

// if (process.env.NODE_ENV === 'production') {
//   ReactGA.initialize('UA-91449158-6')
//   history.listen(function (location) {
//     ReactGA.set({ page: window.location.pathname })
//     ReactGA.pageview(window.location.pathname)
//   })
// }

const renderApp = (props) => {
  if (!auth.isAuthenticated()) {
    return <Redirect to="/login" />;
  }

  return <RootContainer auth={auth} {...props} />;
};

const NoMatch = ({ location }) => (
  <div>
    <h3>
      No match for <code>{location.pathname}</code>
    </h3>
  </div>
);

render(
  <Provider store={store}>
    <Router history={history}>
      <div className="InsideApp">
        <Header auth={auth} />
        <Switch>
          <Route path="/" exact component={renderApp} />
          <Route
            path="/login"
            render={(props) => {
              if (auth.isAuthenticated()) {
                return <Redirect to="/" />;
              }
              return <Login auth={auth} {...props} />;
            }}
          />
          <Route
            path="/callback"
            render={(props) => {
              handleAuthentication(props);
              return <Callback {...props} />;
            }}
          />
          <Route component={NoMatch} />
        </Switch>
      </div>
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js